import { Box, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Modal, Radio, RadioGroup, Typography } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import React from "react";
import Close from "../../Components/Icons/Close";
import cssClasses from "./PreviewAgreementConfirm.module.css";
import Button from "../../Subcomponents/Button";
import { makeStyles } from "@mui/styles";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import { dismissLoader, presentLoader } from "../../Services/loader";
import DropDown from "../../Subcomponents/DropDown";
import { useEffect } from "react";
import { errorTost } from "../../Services/Toast";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import AllotmentBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import Dot from "../../Components/Icons/Dot";
import ExpandedIcon from "../../Assets/Images/Common/chevron-right.svg";
import { addCRMLogs, getAgreement, getAgreementForm, getBankList, getNBFCList, updateCRMAgreement } from "../../Services/Agreement";
import AgreementOPTConfim from "../AgreementOTPConfirm/AgreementOPTConfim";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";

const useStyles = makeStyles((theme) => ({
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "0.7rem",
		top: "0.2rem",
	},
	stepper: {
		"& .MuiLinearProgress-root": {
			backgroundColor: "rgba(82, 108, 130, 0.1) !important",
			height: "0.8rem !important",
			borderRadius: "5rem !important",
			width: "100% !important",
			"& .MuiLinearProgress-bar": {
				backgroundColor: "#155EEF !important",
			},
		},
	},
}));

const PreviewAgreementConfirm = ({ open, handleClose, allotment }) => {
	const classes = useStyles();
	const [checkData, setCheckData] = useState({ check1: false, check2: false, check3: false });
	const [openOTPConfirmationModal, setOpenOTPConfirmationModal] = useState(false);
	const [openAgreementConfirmationModal, setOpenAgreementConfirmationModal] = useState(false);
	const [draftUrl, SetDraftUrl] = useState("");

	useEffect(() => {
		presentLoader();
		console.log("allotment", allotment);
		setCheckData({
			check1: allotment?.CRM[0]?.isSlotBookingOtpVerified ? true : false,
			check2: allotment?.CRM[0]?.isSlotBookingOtpVerified ? true : false,
			check3: allotment?.CRM[0]?.isSlotBookingOtpVerified ? true : false,
		});
		getAgreementForm(allotment?.allotmentPaymentId)
			.then((resp) => {
				console.log(resp);
				if (resp.data[0]?.agreementSuccess && resp.data[0]?.agreementSuccess?.draft_link !== "") {
					const url = resp.data[0]?.agreementSuccess?.draft_link;
					// window.open(url, "_blank");
					SetDraftUrl(url);
					dismissLoader();
				} else {
					errorTost("Could not get Agreement Draft!");
					dismissLoader();
				}
			})
			.catch((err) => {
				errorTost("Could not get Agreement Draft!");
				dismissLoader();
			});
	}, [allotment]);

	function closeModal() {
		handleClose();
	}

	function handleAgreementCheck(rank, value) {
		setCheckData((pre) => {
			pre[rank] = value;
			return { ...pre };
		});
	}

	function ModalResp(e) {
		if (e === "confirmed") {
			console.log(e);
			setOpenOTPConfirmationModal(false);
			presentLoader();
			updateCRMAgreement({ isSlotBookingOtpVerified: true }, allotment?.allotmentPaymentId)
				.then(async (updateRes) => {
					console.log(updateRes);
					if (updateRes.length > 0) {
						let obj = {
							allotmentPaymentId: allotment?.allotmentPaymentId,
							crmStatus: "Agreement Draft Previewed and Confirmed",
							message: `Agreement Draft previewed and confirmed for allotment unit ${allotment?.unitId?.unitNo} of project ${allotment?.unitId?.projectId?.projectName} by the customer`,
						};
						addCRMLogs(obj)
							.then((leadLog) => {
								console.log(leadLog);
							})
							.catch((err) => {
								console.log("CRMlog", err);
							});
						setOpenAgreementConfirmationModal(true);
						dismissLoader();
					} else {
						errorTost("Error While Agreement Confirmation");
						dismissLoader();
					}
				})
				.catch((err) => {
					console.log(err);
					errorTost("Error While Agreement Confirmation");
					dismissLoader();
				});
		}
	}

	return (
		<>
			<Modal
				open={open}
				onClose={(_, reason) => {
					if (reason !== "backdropClick") {
						closeModal();
					}
				}}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={[
					{
						".MuiBackdrop-root": {
							background: "rgba(52, 64, 84, 0.7)",
						},
					},
				]}
				disableAutoFocus={true}
			>
				<Box>
					<Box className={cssClasses.modalWrapper}>
						<div className={cssClasses.wrapperContent}>
							<div className={cssClasses.wrapperHeader}>
								<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
									<Close width={"1.2rem"} height={"1.2rem"} />
								</span>
								<div className={cssClasses.allotmentCardHeader}>
									<div className={cssClasses.allotmentTokenNumWrap}>
										<div className={cssClasses.allotmentImg}>
											<img src={AllotmentBuildingIcon} alt="allotment" />
										</div>
										<div className={cssClasses.allotmentProjectDetail}>
											<div className={cssClasses.allotmentProjectDetailFirst}>
												<span>
													{allotment?.unitId && (
														<span>
															{allotment?.unitId.wingId.displayName
																? allotment?.unitId.wingId.displayName
																: allotment?.unitId.wingId.wingName}{" "}
															- {allotment?.unitId.unitNo}
														</span>
													)}
													{allotment?.inventoryMergedId &&
														((allotment?.inventoryMergedId.unit1Id.wingId.wingId ===
															allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
															<span>
																{allotment?.inventoryMergedId.unit1Id.wingId.displayName
																	? allotment?.inventoryMergedId.unit1Id.wingId.displayName
																	: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
																- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
																{allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
															</span>
														)) ||
															(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
																allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
																<span>
																	{allotment?.inventoryMergedId.unit1Id.wingId.displayName
																		? allotment?.inventoryMergedId.unit1Id.wingId.displayName
																		: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
																	- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
																	{allotment?.inventoryMergedId.unit2Id.wingId.displayName
																		? allotment?.inventoryMergedId.unit2Id.wingId.displayName
																		: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
																	- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
																</span>
															)))}
												</span>
												<div className={cssClasses.tokenStatus}>
													{allotment.unitCost?.sdr - allotment?.paidAmt?.sdr > 0 ? (
														<LeadStatusChip
															label={"SDR Pending"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#B54708",
																backgroundColor: "#FFFAEB",
															}}
														/>
													) : (
														<LeadStatusChip
															label={"SDR Complete"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#027A48",
																backgroundColor: "#ECFDF3",
															}}
														/>
													)}
												</div>
											</div>
											<div className={cssClasses.allotmentProjectName}>
												{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
												{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
											</div>
										</div>
									</div>
									<Button
										disable={
											allotment?.CRM[0]?.isSlotBookingOtpVerified || !checkData.check1 || !checkData.check2 || !checkData.check3
										}
										btnName="Confirm"
										style={{
											color: "#fff",
											backgroundColor: "rgb(21, 112, 239)",
											fontSize: "1.4rem",
											lineHeight: "2rem",
											fontFamily: "Inter-Medium !important",
											width: "20%",
										}}
										clicked={() => {
											setOpenOTPConfirmationModal(true);
										}}
									></Button>
								</div>
							</div>

							<div className={cssClasses.cardBody}>
								<div className={cssClasses.cardContentData}>
									<div className={cssClasses.documentContainer}>
										{draftUrl !== "" && <iframe src={draftUrl} frameBorder="0" title={`Preview Agreement`}></iframe>}
									</div>

									<div className={cssClasses.inputFieldsMainContent}>
										<div className={cssClasses.termsConditionContent}>
											<div className={cssClasses.termsBlock}>
												<FormControlLabel
													sx={{
														"& .MuiTypography-root": {
															fontSize: "1.4rem",
															fontFamily: "Inter-Regular",
															lineHeight: "1.8rem",
														},
														"MuiFormControlLabel-root": {
															display: "flex",
															alignItems: "flex-start ",
															gap: "1rem !important",
														},
													}}
													label={
														<Typography alignItems={"flex-start"}>
															I hereby acknowledge that I have thoroughly reviewed all the details provided in this form
															and affirm that they are accurate and complete to the best of my knowledge. By checking
															this box, I confirm that the form has been duly examined and verified by me
														</Typography>
													}
													control={
														<Checkbox
															disabled={allotment?.CRM[0]?.isSlotBookingOtpVerified}
															checked={checkData.check1}
															onChange={(e) => {
																handleAgreementCheck("check1", e.target.checked);
															}}
															sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
														/>
													}
												/>
											</div>
											<div className={cssClasses.termsBlock}>
												<FormControlLabel
													sx={{
														"& .MuiTypography-root": {
															fontSize: "1.4rem",
															fontFamily: "Inter-Regular",
															lineHeight: "1.8rem",
														},
														"MuiFormControlLabel-root": {
															display: "flex",
															alignItems: "flex-start ",
															gap: "1rem !important",
														},
													}}
													label={
														<Typography alignItems={"flex-start"}>
															I hereby confirm that I have thoroughly reviewed the draft copy of the draft agreement and
															verified that all the details mentioned therein are accurate with my understanding. I
															attest that I have carefully read and acknowledged the contents of the agreement.
														</Typography>
													}
													control={
														<Checkbox
															disabled={allotment?.CRM[0]?.isSlotBookingOtpVerified}
															checked={checkData.check2}
															onChange={(e) => {
																handleAgreementCheck("check2", e.target.checked);
															}}
															sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
														/>
													}
												/>
											</div>
											<div className={cssClasses.termsBlock}>
												<FormControlLabel
													sx={{
														"& .MuiTypography-root": {
															fontSize: "1.4rem",
															fontFamily: "Inter-Regular",
															lineHeight: "1.8rem",
														},
														"MuiFormControlLabel-root": {
															display: "flex",
															alignItems: "flex-start ",
															gap: "1rem !important",
														},
													}}
													label={
														<Typography alignItems={"flex-start"}>
															I/We have read all the terms and conditions of the application form for the Allotment of
															the unit and agreed to abide by the same. Also checked and agreed on the final cost sheet
															shared with me/us through an email. Further, i/we hereby authorise Vilas Javdekar
															Developers, to pay Stamp duty and Registration challan / ESBTR to Govt. Of Maharashtra on
															my behalf based on our provided information. In any event of breach of
															contract/cancellation, I shall be responsible for bear the losses and shall be solely
															responsible for any refund and follow-up with Govt. if applicable.
														</Typography>
													}
													control={
														<Checkbox
															disabled={allotment?.CRM[0]?.isSlotBookingOtpVerified}
															checked={checkData.check3}
															onChange={(e) => {
																handleAgreementCheck("check3", e.target.checked);
															}}
															sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
														/>
													}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Box>
				</Box>
			</Modal>
			<>
				{openOTPConfirmationModal && (
					<AgreementOPTConfim
						open={openOTPConfirmationModal}
						confirm={(e) => {
							ModalResp(e);
						}}
						handleClose={() => setOpenOTPConfirmationModal(false)}
					/>
				)}
				{openAgreementConfirmationModal && (
					<ConfirmationAlert
						open={openAgreementConfirmationModal}
						close={() => setOpenAgreementConfirmationModal(false)}
						returnRespButton={"Close"}
						title={"Agreement Confirmed successfully"}
						confirm={(e) => {
							setOpenAgreementConfirmationModal(false);
							handleClose();
						}}
					/>
				)}
			</>
		</>
	);
};

export default PreviewAgreementConfirm;
